module.exports = __webpack_public_path__ + "img/pattern.9f5d1f9d.svg";